import q3poTheme from "@/themes/q3po-theme";
import q3poThemePalette from "@/themes/q3po-theme-palette";
import q3poSemanticPalette from "@/themes/q3po-semantic-palette";
import { withFontFloor } from "@/themes/font-floor.mjs";

export const WORKSPACE_FONT_FLOOR_VARIANT = "regular";

const workspaceTheme = withFontFloor(q3poTheme, q3poThemePalette, WORKSPACE_FONT_FLOOR_VARIANT);

export function applyQ3poTheme(styleStore, { workspace = false } = {}) {
  styleStore.setThemeData(
    styleStore.DEFAULT_THEME_ID,
    workspace ? workspaceTheme : q3poTheme,
    q3poThemePalette,
    q3poSemanticPalette,
    window.blclient.data.appId,
  );
}
